module.exports = __webpack_public_path__ + "img/how-we-work-banner-3.c8817f9e.png";